// AcusoPreviewModal — previsualiza el acuso de recibo (asunto + cuerpo, el MISMO
// template que el envío real vía GET /mailEntrante/:id/acuso-preview) y permite
// enviarlo. El envío pide confirmación. Reusable: OcEntrantes y CustomerOrders.
//
// Props:
//   mailId   — id del mailEntrante a acusar (si null, no renderiza)
//   onClose  — cerrar el modal
//   onSent   — callback tras enviar OK (para recargar la lista)
import React, { useEffect, useState } from "react";
import backend from "../../backend";

const AcusoPreviewModal = ({ mailId, onClose, onSent }) => {
  const [prev, setPrev] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (!mailId) return;
    setCargando(true); setError(null); setPrev(null);
    backend.get(`mailEntrante/${mailId}/acuso-preview`)
      .then(({ data }) => setPrev(data))
      .catch(e => setError(e?.response?.data?.message || e.message))
      .finally(() => setCargando(false));
  }, [mailId]);

  if (!mailId) return null;

  const enviar = async () => {
    if (!window.confirm("¿Enviar el acuso de recibo al remitente?")) return;
    setEnviando(true); setError(null);
    try {
      await backend.post(`mailEntrante/${mailId}/acuso`);
      onSent && onSent();
      onClose && onClose();
    } catch (e) {
      setError(e?.response?.data?.message || e.message);
    }
    setEnviando(false);
  };

  const puedeEnviar = prev && !prev.yaEnviado && !prev.esEnviado && !enviando;

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.55)", zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "#242424", border: "1px solid #2e2e2e", borderRadius: 10,
        width: "min(560px, 100%)", maxHeight: "85vh", overflow: "auto", color: "#ddd",
        fontFamily: "Arial, sans-serif", boxShadow: "0 10px 40px rgba(0,0,0,.5)",
      }}>
        <div style={{ padding: "14px 18px", borderBottom: "1px solid #2e2e2e", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <strong style={{ color: "#fff", fontSize: 15 }}>Previsualizar acuso de recibo</strong>
          <span onClick={onClose} style={{ cursor: "pointer", color: "#999", fontSize: 20, lineHeight: 1 }}>×</span>
        </div>

        <div style={{ padding: 18 }}>
          {cargando && <div style={{ color: "#aaa", fontSize: 13 }}>Cargando…</div>}
          {error && <div style={{ color: "#e74c3c", fontSize: 13, marginBottom: 10 }}>{error}</div>}

          {prev && (
            <>
              {prev.yaEnviado && (
                <div style={{ color: "#2ecc71", fontSize: 12, marginBottom: 10 }}>
                  ✓ Ya se acusó{prev.acuso?.fecha ? ` el ${new Date(prev.acuso.fecha).toLocaleDateString("es-CL")}` : ""}{prev.acuso?.por ? ` (${prev.acuso.por})` : ""}.
                </div>
              )}
              {prev.esEnviado && (
                <div style={{ color: "#f39c12", fontSize: 12, marginBottom: 10 }}>
                  Este correo salió DESDE recepcion@ — no corresponde acusar recibo.
                </div>
              )}
              <Campo label="Para" valor={prev.para || "(sin remitente)"} />
              <Campo label="Asunto" valor={prev.asunto} />
              <div style={{ fontSize: 10, color: "#999", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 4 }}>Cuerpo</div>
              <pre style={{
                whiteSpace: "pre-wrap", wordBreak: "break-word", background: "#1a1a1a",
                border: "1px solid #2e2e2e", borderRadius: 6, padding: 12, margin: 0,
                fontSize: 12.5, color: "#ddd", fontFamily: "Arial, sans-serif",
              }}>{prev.cuerpo}</pre>
            </>
          )}
        </div>

        <div style={{ padding: "12px 18px", borderTop: "1px solid #2e2e2e", display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button onClick={onClose} style={btn("#333", "#ddd")}>Cerrar</button>
          <button onClick={enviar} disabled={!puedeEnviar}
            style={{ ...btn("#2ecc71", "#0b3d1e"), opacity: puedeEnviar ? 1 : 0.5, cursor: puedeEnviar ? "pointer" : "not-allowed" }}>
            {enviando ? "Enviando…" : "Enviar acuso"}
          </button>
        </div>
      </div>
    </div>
  );
};

const Campo = ({ label, valor }) => (
  <div style={{ marginBottom: 10 }}>
    <div style={{ fontSize: 10, color: "#999", textTransform: "uppercase", letterSpacing: ".05em" }}>{label}</div>
    <div style={{ fontSize: 13, color: "#eee" }}>{valor}</div>
  </div>
);

const btn = (bg, fg) => ({
  background: bg, color: fg, border: "none", borderRadius: 6,
  padding: "7px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer",
  fontFamily: "Arial, sans-serif",
});

export default AcusoPreviewModal;
